import { ReactNode, useId } from 'react';
import Button from '@mui/material/Button';

import Modal from "~/components/Modal";
import { classNames } from "~/utils/utils";

import "./style.less";
import { trans } from "~/utils/trans";

interface IModal {
	msg?: string;
	// nadpis, ikona vystrahy a vlastni obsah - podrobnejsi potvrzeni
	title?: string;
	warning?: boolean;
	children?: ReactNode;
	confirmLabel?: string;
	cancelLabel?: string;
	onConfirm?: () => void;
	onClose?: () => void;
}

// zluty trojuhelnik se zaoblenymi rohy a vykricnikem, zluta jako zaplacene dny v kalendari
function WarningIcon() {
	const gradientId = `warningGradient${useId().replace(/[^a-zA-Z0-9]/gu, "")}`;

	return <svg className="modal-confirm__icon" viewBox="0 0 24 24" aria-hidden="true">
		<defs>
			<linearGradient id={gradientId} x1="0" y1="0" x2="1" y2="1">
				<stop offset="0" stopColor="#f3f9a6" />
				<stop offset="1" stopColor="#cbc634" />
			</linearGradient>
		</defs>
		<path d="M12 3.5 21.5 20h-19z" fill={`url(#${gradientId})`} stroke={`url(#${gradientId})`} strokeWidth="3" strokeLinejoin="round" />
		<rect x="11" y="9" width="2" height="6.5" rx="1" fill="#282828" />
		<circle cx="12" cy="17.9" r="1.2" fill="#282828" />
	</svg>;
}

export default function ConfirmModal({
	msg = "",
	title = "",
	warning = false,
	children = null,
	confirmLabel = "OK",
	cancelLabel = trans("common.cancel"),
	onConfirm = () => {},
	onClose = () => {},
} : IModal) {
	return <Modal className={classNames(["modal-confirm", title ? "modal-confirm--titled" : ""])} onClose={onClose}>
		{ warning && <WarningIcon /> }
		{ title && <h2 className="modal-confirm__title">{title}</h2> }
		{ msg && <p>{msg}</p> }
		{ children }
		<div className="buttons">
			<Button className="MyButton" onClick={() => onConfirm()} variant="contained">{confirmLabel}</Button>
			<Button className="MyButton" onClick={() => onClose()} variant="contained">{cancelLabel}</Button>
		</div>
	</Modal>;
}
